import script from "./EventInfoTab.vue?vue&type=script&lang=ts&setup=true"
export * from "./EventInfoTab.vue?vue&type=script&lang=ts&setup=true"

import "./EventInfoTab.vue?vue&type=style&index=0&id=09a3a57a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09a3a57a"]])

export default __exports__